/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Protocol_CompletedInputs */

const cs_tasks_protocol_completed = /** @type {(inputs: Tasks_Protocol_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Označeno jako podepsané`)
};

const en_tasks_protocol_completed = /** @type {(inputs: Tasks_Protocol_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marked as signed`)
};

/**
* | output |
* | --- |
* | "Marked as signed" |
*
* @param {Tasks_Protocol_CompletedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const tasks_protocol_completed = /** @type {((inputs?: Tasks_Protocol_CompletedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Protocol_CompletedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_protocol_completed(inputs)
	return cs_tasks_protocol_completed(inputs)
});